import {makeAnalyticsEventId} from 'analytics/Analytics';
import {makeReactContext} from 'lib/makeReactContext';

import {DEFAULT_TAB, MigrationTab} from '../types/MigrationTab';

export interface ConfigMigrationPageContextPayload {
  activeTab: MigrationTab;
  eventGroupId: string;
}

const getDefaultContext = (): ConfigMigrationPageContextPayload => ({
  activeTab: DEFAULT_TAB,
  eventGroupId: makeAnalyticsEventId(),
});

export const ConfigMigrationPageContext = makeReactContext<ConfigMigrationPageContextPayload>(
  getDefaultContext,
  'ConfigMigrationPageContext'
);

/**
 * A context for sharing information from the top-level ConfigMigration page.
 */
export function useConfigMigrationPageContext(): ConfigMigrationPageContextPayload {
  return ConfigMigrationPageContext.useContext();
}
